/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON, FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON, } from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData';
/**
 * Check if a given object implements the FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse interface.
 */
export function instanceOfFxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse(value) {
    if (!('Products' in value) || value['Products'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON(json) {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Products': (json['Products'].map(FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON)),
        'ClientMetadata': json['ClientMetadata'] == null ? undefined : json['ClientMetadata'],
    };
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON(json) {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSONTyped(json, false);
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Products': (value['Products'].map(FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON)),
        'ClientMetadata': value['ClientMetadata'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse.js.map